"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["is", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Usage:
 * <Component is={myComponent} />
 *
 * The `is` prop is required and can be any React elementType, including any regular HTML tag.
 * You can pass any other additional props and they will be passed through to the component you're referencing.
 *
 * Children can be passed as you'd expect as well.
 *
 * @param is
 * @param children
 * @param rest
 * @returns {React.DetailedReactHTMLElement<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>}
 * @constructor
 */
var Component = function Component(_ref) {
  var is = _ref.is,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(is, rest, children);
};

Component.propTypes = process.env.NODE_ENV !== "production" ? {
  is: _propTypes["default"].oneOfType([_propTypes["default"].elementType, _propTypes["default"].string]).isRequired,
  children: _propTypes["default"].element
} : {};
var _default = Component;
exports["default"] = _default;